let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j31Az")).then(() => parcelRequire('24OvT'));